// extracted by mini-css-extract-plugin
module.exports = {"Paggination":"Paggination_Paggination__2Exa5","PageNum":"Paggination_PageNum__1NV77","DiplayNone":"Paggination_DiplayNone__3EO39"};